function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M3.83333 8.16602H5.5V9.83268H3.83333V8.16602ZM15.5 3.99935V15.666C15.5 16.5827 14.75 17.3327 13.8333 17.3327H2.16667C1.24167 17.3327 0.5 16.5827 0.5 15.666L0.508333 3.99935C0.508333 3.08268 1.24167 2.33268 2.16667 2.33268H3V0.666016H4.66667V2.33268H11.3333V0.666016H13V2.33268H13.8333C14.75 2.33268 15.5 3.08268 15.5 3.99935ZM2.16667 5.66602H13.8333V3.99935H2.16667V5.66602ZM13.8333 15.666V7.33268H2.16667V15.666H13.8333ZM10.5 9.83268H12.1667V8.16602H10.5V9.83268ZM7.16667 9.83268H8.83333V8.16602H7.16667V9.83268Z",
  fill: "#DBC7B8"
});

function SvgCalendar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.e18dafad.svg";
export { ForwardRef as ReactComponent };